import { autoinject, computedFrom } from 'aurelia-framework';
import { RouterConfiguration, Router } from 'aurelia-router';
import { UrlService } from '_services/url-service';
import * as Dto from '_models/dtos';
import { EventAggregator } from 'aurelia-event-aggregator';
import { SessionData } from '_models/session-data';
import { DialogService } from 'aurelia-dialog';
import { FeedbackDialog } from 'shell/feedback-dialog';

@autoinject
export class App {
    private _url: UrlService;

    constructor(
        private _eventBus: EventAggregator,
        public sd: SessionData,
        public dialogSvc: DialogService
    ) {
        this._url = new UrlService();
        this.version = (window as any).version;
    }

    version: string;

    attached() {
        this.sd.load();
    }

    detached() {
        this.sd.save();
    }
    
    router: Router = null;
    
    configureRouter(config: RouterConfiguration, router: Router): any {
        
        config.title = 'Benjamin Moore - Spec Writer';

        //var handleUnknownRoutes = (instruction) => {
        //    return { route: 'not-found', moduleId: 'app' };
        //}

        //config.mapUnknownRoutes(handleUnknownRoutes);


        config.options.pushState = true;
        config.options.root = this._url.getBaseHref();
        config.map([
            { route: [ '', '/', 'product-selector'], name: 'product-selector', moduleId: 'product-selector/product-selector', nav: true, title: 'Product Selector' },
            { route: 'project-schedule', name: 'project-schedule', moduleId: 'project-schedule/project-schedule', nav: true, title: 'Project Schedule' },
            { route: 'terms-and-conditions', name: 'terms-and-conditions', moduleId: 'shell/terms-and-conditions', nav: false, title: 'Terms and Conditions' }
        ]);

        this.router = router;
    }

    sendFeedback() {
        this.dialogSvc.open({
            viewModel: FeedbackDialog
        });
    }
}
